import PropTypes from 'prop-types'

import { InboxMessageAttribute } from '../../models/inbox-message/inbox-message-attribute-enum'

const { NAME, VALUE } = InboxMessageAttribute

/**
 * @typedef {Object} InboxMessageAttribute
 *
 * @property {string} [name]    - The inbox message attribute name
 * @property {string} [value]   - The inbox message attribute value
 */
const inboxMessageAttributePropType = PropTypes.shape({
    [NAME]: PropTypes.string,
    [VALUE]: PropTypes.string
})

export { inboxMessageAttributePropType }
